function BuildImage(_selector) {
  this.list = $(_selector);
  this.listNum = this.list.length;
  this.listImageUrls = [];
  this.current = 0;
  this.moving = false;
  for (var i = 0; i < this.listNum; i++) {
    var url = this.list.eq(i).find("img").attr("src");
    this.listImageUrls.push(url);
  }
  imageLoad(this.listImageUrls, this.complete, this);
}

BuildImage.prototype.complete = function(_myself) {
  // $('#pic-top-loading').fadeOut();
  setTimeout(function() {
    _myself.list.eq(0).addClass("show");
  }, 500);
};

// -----------------------------------------

function imageLoad(_images, _complete, _this) {
  var loadCount = 0;
  for (var i = 0; i < _images.length; i++) {
    var img = new Image();
    var src = _images[i].replace(/"/g, "");
    img.src = src + "?" + new Date().getTime();
    img.onload = function() {
      countload();
    };
  }
  function countload() {
    loadCount++;
    if (loadCount == _images.length) {
      _complete(_this);
    }
  }
}

// -----------------------------------------

function Preview() {
  var myself = this;
  this.iframe = $("#js-iframe");
  this.thumbImage = this.document = this.iframe.get(0).contentWindow.document;
  this.iframeHeight = 0;
  this.thumbNum = 0;
  this.imageid = $(".imageid").val();
  this.init();
  this.changeIframe();
}

Preview.prototype.reload = function() {};

Preview.prototype.reset = function() {};

Preview.prototype.changeIframe = function(_url) {
  loadIn();
  var date = new Date();
  // var newSrc = '/order/preview?taste=cool&news=news-headline';

  // var newSrc = $('#js-order-build .active img').data('iframe');
  var newSrc = "/order/preview/";

  this.iframe[0].contentDocument.location.replace(newSrc);
  this.loadIframe();
};

Preview.prototype.loadIframe = function() {
  var myself = this;

  this.iframe.on("load", function(e) {
    myself.document = myself.iframe.get(0).contentWindow.document;
    myself.getHeight();
    loadOut();
  });
};

Preview.prototype.getHeight = function(_url) {
  var myself = this;
  this.iframeHeight = Math.max(this.document.body.scrollHeight, this.document.documentElement.scrollHeight, this.document.body.offsetHeight, this.document.documentElement.offsetHeight, this.document.body.clientHeight, this.document.documentElement.clientHeight);
  this.setHeight();
};

Preview.prototype.setHeight = function(_url) {
  this.iframe.removeAttr("height").css("height", this.iframeHeight + "px");
};

Preview.prototype.thumbChange = function(_num) {
  $("#js-order-build li").removeClass("active");
  $("#js-order-build-tab li").removeClass("active");
  $("#js-order-build li").eq(_num).addClass("active");
  $("#js-order-build-tab li").eq(_num).addClass("active");
  $("#js-preview iframe").removeClass("show");
  $("#js-preview iframe").eq(_num).addClass("show");
  $("input[name=material]:eq(" + _num + ")").prop("checked", true);

  // var previewsrc = $('#js-order-build li').eq(_num).data('preview');
  // $('#js-open-blank').attr('href',previewsrc);
};

Preview.prototype.init = function() {
  var myself = this;

  $("#js-preview-pc").on("click", function() {
    if ($(this).hasClass("active")) {
      return false;
    }
    $("#js-preview-pc").addClass("active");
    $("#js-preview-sp").removeClass("active");
    $("#js-preview-size").removeClass("spmode");

    myself.iframe.attr("style", "");
    myself.getHeight();
  });

  $("#js-preview-sp").on("click", function() {
    if ($(this).hasClass("active")) {
      return false;
    }
    $("#js-preview-pc").removeClass("active");
    $("#js-preview-sp").addClass("active");
    $("#js-preview-size").addClass("spmode");
    myself.iframe.attr("style", "");
    myself.getHeight();
  });

  $(document).on("click", "#js-order-build li", function() {
    if ($(this).hasClass("active")) {
      return false;
    }
    const num = $("#js-order-build li").index($(this));
    myself.thumbChange(num);
    myself.changeIframe();
  });

  function showSide() {
    $("#js-side-bg").fadeIn(150);
    setTimeout(function() {
      $(".js-side-content").addClass("show");
    }, 150);
  }

  function hideSide() {
    $("#js-side-bg").fadeOut(150);
    setTimeout(function() {
      $(".js-side-content").removeClass("show");
    }, 150);
  }

  $(".js-side-show").on("click", showSide);
  $("#js-side-bg").on("click", hideSide);

  // $(document).on("click", ".js-change-thumb", function(){
  // 	myself.thumbNum = $('.js-change-thumb').index($(this));
  // });
  // $(document).on("click", ".js-thumb-image-remove", function(){
  // 	$(this).next().val('');
  // 	$(this).parent().addClass('noimage');
  // });
  //
  // $(document).on("click", ".js-thumbs-list li", function(){
  // 	if($(this).hasClass('active')){
  // 		return false;
  // 	}
  // 	$('.js-thumbs-list li').removeClass('active');
  // 	$(this).addClass('active');
  // 	myself.imageid = $(this).data('imageid');
  // 	$(".changeable-image").removeClass('noimage');
  // 	$(".imageid").eq(myself.thumbNum).val(myself.imageid);
  // 	var src = '/static/website/images/message/'+ myself.imageid +'.jpg';
  // 	$(".js-thumb-image").eq(myself.thumbNum).attr('src',src);
  //
  // 	hideModal();
  // });
  // $('.js-thumbs-list li').each(function(){
  // 	if($(this).data('imageid') == myself.imageid){
  // 		$(this).addClass('active');
  // 		return false;
  // 	}
  // });

  // var previewsrc = $('#js-order-build li').eq(0).data('preview');
  // $('#js-open-blank').attr('href',previewsrc);
};

$(document).on("submit", "#fixedform", reloadiframe);

function reloadiframe() {
  loadIn();
  $("#js-side-bg").fadeOut(150);
  $(".js-side-content").removeClass("show");
  var form = $("#fixedform").get()[0];
  var formData = new FormData(form);

  // Ajaxで送信
  $.ajax({
    url: "/order/update",
    method: "post",
    dataType: "json",
    data: formData,
    processData: false,
    contentType: false,
    timeout: 10000
  }).done(function(res) {
    setTimeout(function() {
      $("#js-iframe")[0].contentDocument.location.reload(true);
      loadOut();
    }, 500);
  }).fail(function(jqXHR, textStatus, errorThrown) {
    alert("保存に失敗しました。");
    loadOut();
  });

  return false;
}

function loadIn() {
  $("#loading").fadeIn(300);
  $(".preview__pic").removeClass("show");
}
function loadOut() {
  $("#loading").fadeOut(300);
  $("#loading__message").fadeOut(300);
  $(".preview__pic").addClass("show");
}

// $(document).on("click", '#js-preview', function(){
// 	var time = $(this).data('time');
// 	var fade = $(this).data('fade');
//
// 	$('.preview-wrap').fadeIn(fade);
// 	setTimeout(function(){
// 		$('.preview-wrap').fadeOut(fade);
// 	},time);
// });

function setListSampleWidth() {
  var listNum = $("#js-order-build li").length;
  var listItemWidth = $("#js-order-build li").eq(0).width();
  var listItemOuterWidth = $("#js-order-build li").eq(0).outerWidth(true);
  var listItemMargin = listItemOuterWidth - listItemWidth;
  $("#js-order-build").width(listNum * listItemOuterWidth - listItemMargin);
}

setListSampleWidth();

if ($("#js-iframe").length > 0) {
  var preview = new Preview();
}
